import ManageValuesList from './ManageValuesList';

export default ManageValuesList;
